export const BookingEntryPayment = {
  Insurance: "insurance",
  SelfPay: "self-pay"
} as const

export type BookingEntryPayment = typeof BookingEntryPayment[keyof typeof BookingEntryPayment]

export function parseBookingEntryPayment(value: string | null): BookingEntryPayment | undefined {
  return Object.values(BookingEntryPayment).find((payment) => payment === value)
}

// Prefix on a bookAppointment FORBIDDEN message that marks a known-data eligibility rejection, as
// opposed to a program-access denial (assertProgramEnabled also throws FORBIDDEN, without a reason).
// The client keys on this to route only eligibility rejections to the not-eligible screen and to
// recover the exclusion reason id from the message. Shared here so the two sides can't drift. (MEM-771)
export const BOOKING_INELIGIBLE_ERROR_PREFIX = "booking_ineligible:"

// A CONFLICT marking a slot or booking session the server will not honour: the client must drop the
// slot and load availability again rather than replay the token, which can create a second
// appointment. No BFF procedure emits it today (MEM-1043 removed the cross-backend check that did),
// so the client handling below is inert until something answers it again. Kept because the handling
// is the correct response if anything does.
export const BOOKING_SESSION_EXPIRED = "BOOKING_SESSION_EXPIRED"

export const BOOKING_RECOVERY_ACTIONS = [
  "pending",
  "retry",
  "choose_new_slot",
  "update_payment",
  "start_over",
  "contact_support"
] as const

export type BookingRecoveryAction = typeof BOOKING_RECOVERY_ACTIONS[number]

export type BookingRecovery = {
  action: BookingRecoveryAction
  restartSafe: boolean
  appointmentCreated: boolean
  paymentCaptured: boolean
  retryAfterSeconds?: number
  resolveBy?: string
}
